import { SampleType } from "./GovPoolModel/CollectionTypeResponse"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GetPanels(labAccountCode: string, DeviceID: number = 0) {
  return ObservableFromFetch<SampleType[]>(
    "GovPool/GetPanels?labAccountCode=" + labAccountCode + "&DeviceID=" + DeviceID
  )
}
export function GovGetLabDeviceDrugs(sampleTypeCode: string, labAccountCode: string, DeviceID: number = 0, AccountID: number) {
  return ObservableFromFetch<SampleType[]>(
    "GovOrder/GetLabDeviceDrugs?sampleTypeCode=" +
      sampleTypeCode +
      "&labAccountCode=" +
      labAccountCode +
      "&deviceId=" +
      DeviceID +
      "&accountId=" +
      AccountID
  )
}
